(function () {
    'use strict';

    angular
        .module('gwApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider', '$rootScopeProvider'];

    /**
     * Created by vimpans on 2019/8/21
     */

    function stateConfig($stateProvider) {
        $stateProvider
            .state('negotiation', {
                parent: 'module',
                url: '/negotiation',
                data: {
                    authorities: []
                },
                views: {
                    'content': {
                        templateUrl: 'app/module/negotiation/negotiation.html',
                        controller: 'NegotiationController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        return $translate.refresh();
                    }]
                }
            })
    }
})();
